// components/Header.tsx
'use client';
import { useState, useEffect } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Logo from '@images/ic-logo.svg';
import BackArrow from '@images/BackArrow.svg';
import { navigationConfig, MenuItem } from '@/config/navigation';

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>({});
  const [headerMenu] = useState([...navigationConfig]);

  const toggleMenu = (label: string) => {
    setOpenMenus((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  const renderMenuItem = (item: MenuItem) => {
    if (item.children) {
      return (
        <li
          key={item.label}
          className={`nav-item dropdown ${openMenus[item.label] ? 'show' : ''}`}
        >
          <a
            onClick={() => toggleMenu(item.label)}
            aria-expanded={openMenus[item.label]}
            role="button"
            className="dropdown-toggle nav-link"
            href="#"
            target={item.target}
          >
            {item.label}
          </a>
          <div
            data-bs-popper="static"
            className={`dropdown-menu ${openMenus[item.label] ? 'show' : ''}`}
            aria-labelledby=""
          >
            <button
              onClick={() => toggleMenu(item.label)}
              className="back-link dropdown-toggle"
              id="navbarCoursesDropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <Image
                src={BackArrow}
                className="past-courses__cards__arrow back-link"
                alt="back arrow"
                width={24}
                height={24}
              />
            </button>
            <div className="dropdown-menu-col" data-title={item.label}>
              {item.children.map((child) => {
                if (child.children) {
                  return (
                    <div
                      className="dropdown-menu-inner"
                      data-title={child.label}
                      key={child.label}
                    >
                      <div className="dropdown-menu-col">
                        <h6 className="dropdown-header">{child.label}</h6>
                        {child.children.map((subChild) => (
                          <a
                            key={subChild.label}
                            data-rr-ui-dropdown-item=""
                            className={`dropdown-item ${subChild.label === 'All Courses' ? 'active' : ''} ${subChild.label === 'Help me choose' ? 'help' : ''}`}
                            href={subChild.path}
                            target={subChild.target}
                          >
                            {subChild.label}
                          </a>
                        ))}
                      </div>
                    </div>
                  );
                }
                return (
                  <a
                    key={child.label}
                    data-rr-ui-dropdown-item=""
                    className="dropdown-item"
                    href={child.path || '#'}
                    target={child.target}
                  >
                    {child.label}
                  </a>
                );
              })}
            </div>
          </div>
        </li>
      );
    }

    return (
      <li key={item.label} className="nav-item">
        <Link href={item.path || '#'} passHref legacyBehavior>
          <a data-rr-ui-event-key={item.path} className="nav-link">
            {item.label}
          </a>
        </Link>
      </li>
    );
  };

  return (
    <header className={`header header-v2 ${isOpen ? 'menu-opened' : ''}`}>
      <div className="header__container container">
        <Link href="/us-en" passHref legacyBehavior>
          <a className="logo">
            <Image
              src={Logo}
              alt="logo"
              className="logo__image"
              width={115}
              height={45}
            />
          </a>
        </Link>
        <nav className="navbar navbar-expand-lg navbar-light">
          <button
            onClick={() => {
              setIsOpen(!isOpen);

              // Remove "show" class from all dropdown-menu elements
              const dropdownMenus = document.querySelectorAll(
                '.dropdown-menu.show'
              );
              dropdownMenus.forEach((menu) => menu.classList.remove('show'));

              // Remove "show" class from all li.nav-item elements
              const navItems = document.querySelectorAll('li.nav-item.show');
              navItems.forEach((item) => item.classList.remove('show'));
            }}
            aria-controls="basic-navbar-nav"
            type="button"
            aria-label="Toggle navigation"
            className={`navbar-toggler-header navbar-toggler ${isOpen ? '' : 'collapsed'}`}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar top-bar"></span>
            <span className="icon-bar middle-bar"></span>
            <span className="icon-bar bottom-bar"></span>
          </button>
          <div
            className={`navbar-collapse collapse ${isOpen ? 'show' : ''}`}
            id="basic-navbar-nav"
          >
            <div className="nav-logowrap">
              <Image
                src={Logo}
                alt="logo"
                className="logo__image"
                width={115}
                height={45}
              />
            </div>
            <ul className="mr-auto navbar-nav">
              {headerMenu.map(renderMenuItem)}
            </ul>
            <div className="mobile-menu-buttons">
              {/* Login button removed */}
            </div>
          </div>
        </nav>
        {/* User profile section removed */}
      </div>
    </header>
  );
}
